module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.setWrapperClass
  }, [_c('input', {
    staticClass: "checkbox__input",
    attrs: {
      "id": _vm.setId,
      "name": _vm.setId,
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.value,
      "checked": _vm.setChecked
    },
    on: {
      "change": _vm.saveData
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "label checkbox__label",
    attrs: {
      "for": _vm.setId
    }
  }, [_vm._v(_vm._s(this.label))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3495e102!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Checkbox.vue
// module id = 315
// module chunks = 0